import clsx from 'clsx';
import { type HTMLAttributes } from 'react';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';

import { pageHeaderCSS } from './Page.sty.js';

/**
 * @public
 */
export interface HeaderProps
  extends WithChildren,
    Omit<HTMLAttributes<HTMLDivElement>, keyof StylingProps>,
    StylingProps,
    DataTestId {}

/**
 * The `Header` component is used inside the `Page` component for displaying content at the very top of the page.
 * @public
 */
export const Header = (props: HeaderProps) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
    ...remainingProps
  }: HeaderProps = props;

  return (
    <div
      className={clsx(consumerClassName, pageHeaderCSS)}
      style={consumerStyle}
      data-testid={dataTestId}
      {...remainingProps}
    >
      {children}
    </div>
  );
};

Header.displayName = 'Page.Header';
